import { render, staticRenderFns } from "./AppBanner.vue?vue&type=template&id=2e94fff4&scoped=true"
import script from "./AppBanner.vue?vue&type=script&lang=ts"
export * from "./AppBanner.vue?vue&type=script&lang=ts"
import style0 from "./AppBanner.vue?vue&type=style&index=0&id=2e94fff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94fff4",
  null
  
)

export default component.exports